module.exports = function (c) {
  c.CSS3DObject = function (d) {
    c.Object3D.call(this);
    this.element = d;
    this.element.style.position = "absolute";
    this.element.style.pointerEvents = "auto";
    this.addEventListener("removed", function () {
      this.traverse(function (f) {
        if (f.element instanceof Element && f.element.parentNode !== null) {
          f.element.parentNode.removeChild(f.element);
        }
      });
    });
  };
  c.CSS3DObject.prototype = Object.create(c.Object3D.prototype);
  c.CSS3DObject.prototype.constructor = c.CSS3DObject;
  c.CSS3DSprite = function (d) {
    c.CSS3DObject.call(this, d);
  };
  c.CSS3DSprite.prototype = Object.create(c.CSS3DObject.prototype);
  c.CSS3DSprite.prototype.constructor = c.CSS3DSprite;
  c.CSS3DRenderer = function () {
    function j(K) {
      if (Math.abs(K) < 1e-10) {
        return 0;
      } else {
        return K;
      }
    }
    function k(K) {
      var L = K.elements;
      return (
        "matrix3d(" +
        j(L[0]) +
        "," +
        j(-L[1]) +
        "," +
        j(L[2]) +
        "," +
        j(L[3]) +
        "," +
        j(L[4]) +
        "," +
        j(-L[5]) +
        "," +
        j(L[6]) +
        "," +
        j(L[7]) +
        "," +
        j(L[8]) +
        "," +
        j(-L[9]) +
        "," +
        j(L[10]) +
        "," +
        j(L[11]) +
        "," +
        j(L[12]) +
        "," +
        j(-L[13]) +
        "," +
        j(L[14]) +
        "," +
        j(L[15]) +
        ")"
      );
    }
    function q(K, L) {
      var M = K.elements;
      var N =
        "matrix3d(" +
        j(M[0]) +
        "," +
        j(M[1]) +
        "," +
        j(M[2]) +
        "," +
        j(M[3]) +
        "," +
        j(-M[4]) +
        "," +
        j(-M[5]) +
        "," +
        j(-M[6]) +
        "," +
        j(-M[7]) +
        "," +
        j(M[8]) +
        "," +
        j(M[9]) +
        "," +
        j(M[10]) +
        "," +
        j(M[11]) +
        "," +
        j(M[12]) +
        "," +
        j(M[13]) +
        "," +
        j(M[14]) +
        "," +
        j(M[15]) +
        ")";
      if (I) {
        return "translate(-50%,-50%)translate(" + B + "px," + C + "px)" + L + N;
      } else {
        return "translate(-50%,-50%)" + N;
      }
    }
    function v(K, L, M, N) {
      if (K instanceof c.CSS3DObject) {
        var O;
        K.onBeforeRender(D, L, M);
        if (K instanceof c.CSS3DSprite) {
          E.copy(M.matrixWorldInverse);
          E.transpose();
          E.copyPosition(K.matrixWorld);
          E.scale(K.scale);
          E.elements[3] = 0;
          E.elements[7] = 0;
          E.elements[11] = 0;
          E.elements[15] = 1;
          O = q(E, N);
        } else {
          O = q(K.matrixWorld, N);
        }
        var P = K.element;
        var Q = F.objects.get(K);
        if (Q === undefined || Q.style !== O) {
          P.style.WebkitTransform = O;
          P.style.transform = O;
          var R = {
            style: O,
          };
          if (I) {
            R.distanceToCameraSquared = J(M, K);
          }
          F.objects.set(K, R);
        }
        P.style.display = K.visible ? "" : "none";
        if (P.parentNode !== H) {
          H.appendChild(P);
        }
        K.onAfterRender(D, L, M);
      }
      for (var S = 0, T = K.children.length; S < T; S++) {
        v(K.children[S], L, M, N);
      }
    }
    function w(K) {
      var L = [];
      K.traverse(function (M) {
        if (M instanceof c.CSS3DObject) {
          L.push(M);
        }
      });
      return L;
    }
    function x(K) {
      var L = w(K).sort(function (P, Q) {
        return (
          F.objects.get(P).distanceToCameraSquared -
          F.objects.get(Q).distanceToCameraSquared
        );
      });
      var M = L.length;
      for (var N = 0, O = L.length; N < O; N++) {
        L[N].element.style.zIndex = M - N;
      }
    }
    var z;
    var A;
    var B;
    var C;
    var D = this;
    var E = new c.Matrix4();
    var F = {
      camera: {
        fov: 0,
        style: "",
      },
      objects: new WeakMap(),
    };
    var G = document.createElement("div");
    G.style.overflow = "hidden";
    this.domElement = G;
    var H = document.createElement("div");
    H.style.WebkitTransformStyle = "preserve-3d";
    H.style.transformStyle = "preserve-3d";
    H.style.pointerEvents = "none";
    G.appendChild(H);
    var I = /Trident/i.test(navigator.userAgent);
    this.getSize = function () {
      return {
        width: z,
        height: A,
      };
    };
    this.setSize = function (K, L) {
      B = (z = K) / 2;
      C = (A = L) / 2;
      G.style.width = K + "px";
      G.style.height = L + "px";
      H.style.width = K + "px";
      H.style.height = L + "px";
    };
    var J = (function () {
      var K = new c.Vector3();
      var L = new c.Vector3();
      return function (M, N) {
        K.setFromMatrixPosition(M.matrixWorld);
        L.setFromMatrixPosition(N.matrixWorld);
        return K.distanceToSquared(L);
      };
    })();
    this.render = function (K, L) {
      var M = L.projectionMatrix.elements[5] * C;
      if (F.camera.fov !== M) {
        if (L.isPerspectiveCamera) {
          G.style.WebkitPerspective = M + "px";
          G.style.perspective = M + "px";
        } else {
          G.style.WebkitPerspective = "";
          G.style.perspective = "";
        }
        F.camera.fov = M;
      }
      if (K.autoUpdate === true) {
        K.updateMatrixWorld();
      }
      if (L.parent === null) {
        L.updateMatrixWorld();
      }
      if (L.isOrthographicCamera) {
        var N = -(L.right + L.left) / 2;
        var O = (L.top + L.bottom) / 2;
      }
      var P = L.isOrthographicCamera
        ? "scale(" +
          M +
          ")translate(" +
          j(N) +
          "px," +
          j(O) +
          "px)" +
          k(L.matrixWorldInverse)
        : "translateZ(" + M + "px)" + k(L.matrixWorldInverse);
      var Q = P + "translate(" + B + "px," + C + "px)";
      if (F.camera.style !== Q && !I) {
        H.style.WebkitTransform = Q;
        H.style.transform = Q;
        F.camera.style = Q;
      }
      v(K, K, L, P);
      if (I) {
        x(K);
      }
    };
  };
  c.CSS3DRenderer.prototype = Object.create(c.EventDispatcher.prototype);
  c.CSS3DRenderer.prototype.constructor = c.CSS3DRenderer;
  return;
};
